import { Navigate } from "react-router-dom";
import { useAppSelector, RootState } from "store/rootReducer";
import { LoadSpinner } from "features/LoadSpinner";

const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const authState = useAppSelector((state: RootState) => state.auth);
  const profileState = useAppSelector((state: RootState) => state.profile);

  const shouldShowSpinner = !authState || !profileState || authState.loading;

  if (shouldShowSpinner) {
    return <LoadSpinner loading={true} />;
  }

  const { accessToken } = authState;
  const { userCustomerProfile } = profileState;

  if (accessToken && userCustomerProfile) {
    return userCustomerProfile.type === 0 ? (
      <Navigate to="/audiences" replace />
    ) : (
      <Navigate to="/dashboard" replace />
    );
  }

  return <>{children}</>;
};

export default PublicRoute;
